export default {
  SET_USER_PROJECTS: (state, payload) => state.userProjects = payload || [],
}